import React from 'react';
import PropTypes from 'prop-types';

export default class LabelView extends React.Component {
  static propTypes = {
    col: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    status: PropTypes.string,
    html: PropTypes.bool,
    name: PropTypes.string,
    onMouseUp: PropTypes.func
  };

  static defaultProps = {
    col: 'col-md-12',
    title: '',
    text: '-',
    status: '',
    html: false,
    name: null,
    onMouseUp: null
  };

  render() {
    return (
      <>
        <style>
          {`
        .note-editable ul {
          list-style-type: disc ;
          margin-left: 20px;
        }
      `}
        </style>
        <div className={`label-text label-view ${this.props.col}`} >
          <dl>
            <dt style={{ color: '#453166' }} >{this.props.title}</dt>
            <dd className={this.props.status} name={this.props.name}>
              {
                this.props.html && this.props.text ?
                  <div className='note-editable ul' onMouseUp={this.props.onMouseUp} dangerouslySetInnerHTML={{ __html: `${this.props.text}` }} /> :
                  this.props.text || '-'
              }
            </dd>
          </dl>
        </div>
      </>
    );
  }
}
